export default __webpack_public_path__ + "static/media/8-min.a061ec34.jpg";